import { store } from './Store';
import {
  LOYALTY_COINS_CALL_CENTER,
  LOYALTY_COINS_DISABLED,
  LOYALTY_COINS_ENABLED,
  LOYALTY_NEW_USER_MAX_DISCOUNT_PERCENTAGE,
} from './constants';
import { LOYALTY_STATUS } from './actions/Loyalty';
import { isCallCenterUser } from './utils/Generic';

const showLoyaltyClaimPopup = () => {
  const state = store.getState();
  let { agentCode } = state.booking;
  // const { agentSell } = state.booking;
  if (agentCode == null) {
    agentCode = '';
  }

  //if (!state.loyalty.showClaimPopup || !state.session.chainData
  //|| (agentCode !== '' && agentSell === 'false')) {
  if (!state.loyalty.showClaimPopup || !state.session.chainData || agentCode !== '') {
    // No se mostrará el pop up de login de loyalty si hay un agentCode
    // y si agentSell es falso, ya que eso indica que el agente está entrando
    // para hacer reservas para él mismo, no para vender a algún cliente
    //CONTROL DE LOGIN EN LOYALTY
    return false;
  }
  if (state.session.chainData.loyalty_coins_active === LOYALTY_COINS_CALL_CENTER) {
    return isCallCenterUser(state.session);
  }
  return state.session.chainData.loyalty_coins_active === LOYALTY_COINS_ENABLED;
};

const showLoyaltyRegisterNow = () => {
  const state = store.getState();
  if (state.loyalty.loggedUser) {
    return false;
  }
  if (state.session.chainData.loyalty_coins_active === LOYALTY_COINS_CALL_CENTER) {
    return isCallCenterUser(state.session);
  }
  return state.session.chainData.loyalty_coins_active === LOYALTY_COINS_ENABLED;
};

const showLoyaltyRedeem = () => {
  const state = store.getState();
  if (isCallCenterUser(state.session)) {
    return state.session.chainData.loyalty_coins_active !== LOYALTY_COINS_DISABLED
      && state.loyalty.selectedStatus !== LOYALTY_STATUS.DONT_WANT_MEMBER;
  }
  if (state.booking.agentCode != null && state.booking.agentCode !== ''
    && state.booking.agentSell === 'false' && state.booking.agentUseCoins === 'false') {
    // Si es una reserva para el propio agente y no quiere usar coins no se mostrará
    // nada de loyalty
    return false;
  }
  return state.session.chainData.loyalty_coins_active === LOYALTY_COINS_ENABLED;
};

const showLoyaltySelector = () => {
  const state = store.getState();
  if (isCallCenterUser(state.session)) {
    return state.session.chainData.loyalty_coins_active !== LOYALTY_COINS_DISABLED;
  }
  return false;
};

const getMaxCoinsToApply = (price, needConversion = false) => {
  //Metimos acá la parte de obtener los coins dependiendo del porcentaje
  //que le corresponde a los que son nuevos miembros de loyalty
  //Esta es la principal parte donde está todo, debemos asegurar que quede centralizado
  const state = store.getState();
  const {
    memberInfo, coinsForRegistering, conversionRates,
  } = state.loyalty;

  let hotelPrice = price;
  if (needConversion) {
    const currency = state.booking.filterCurrency;
    const conversionRate = conversionRates.find((element) => element.currency_code === currency.code);
    const conversionRateValue = conversionRate !== undefined ? conversionRate.value : 1;
    hotelPrice = price / conversionRateValue;
  }

  if (memberInfo === null || memberInfo.email === '') {
    const availableCoins = coinsForRegistering;
    const maxCoins = Math.round((hotelPrice * LOYALTY_NEW_USER_MAX_DISCOUNT_PERCENTAGE) / 100, 1);
    if (availableCoins > maxCoins) {
      return maxCoins;
    }
    return availableCoins;
  }

  const { availableCoins, discountAvailablePercentage } = memberInfo;
  const maxCoins = Math.round((hotelPrice * discountAvailablePercentage) / 100, 1);
  if (availableCoins > maxCoins) {
    return maxCoins;
  }
  return availableCoins;
};

const convertCoinsToCurrency = (coins, currency = null) => {
  let finalCurrency = currency;
  if (!coins) {
    return 0;
  }
  const state = store.getState();
  const force_conversion_1_eur_or_1_usd_equals_20_mxn_enabled = state.session.chainData.booking_engine_configuration
    .force_loyalty_coins_conversion_rates_to_1_eur_or_1_usd_equals_20_mxn_enabled;
  const {
    conversionRates,
  } = state.loyalty;
  if (finalCurrency == null) {
    // Tuvimos que agregar al método convertCoinsToCurrency el parámetro opcional currency, ya que
    // va al store y toma el currency de state.booking.filterCurrency, lo cual no coincidiría
    // con el currency que se toma de la ip del usuario
    finalCurrency = state.booking.filterCurrency;
  }
  const conversionRate = conversionRates.find((element) => element.currency_code === finalCurrency.code);
  //force_loyalty_coins_conversion_rates_to_1_eur_or_1_usd_equals_20_mxn_enabled
  let conversionRateValue = conversionRate !== undefined ? conversionRate.value : 1;
  if (force_conversion_1_eur_or_1_usd_equals_20_mxn_enabled === true) {
    if (finalCurrency.code === 'EUR' || finalCurrency.code === 'USD') {
      conversionRateValue = 1;
    } else if (finalCurrency.code === 'MXN') {
      conversionRateValue = 20;
    } else if (conversionRate !== undefined) {
      conversionRateValue = conversionRate.value;
    } else {
      conversionRateValue = 1; // Valor por defecto
    }
  }
  return coins * conversionRateValue;
};

const convertCoinsToCurrencyUsingRoundedConversionRate = (coins, currency = null) => {
  // Es igual al método convertCoinsToCurrency pero regresa el resultado redondeado
  // eso lo usamos para redondear el loyalty discount to apply porque en el backend
  // está a dos decimales, entonces para que coincidan los cálculos
  let finalCurrency = currency;
  if (!coins) {
    return 0;
  }
  const state = store.getState();
  const force_conversion_1_eur_or_1_usd_equals_20_mxn_enabled = state.session.chainData.booking_engine_configuration
    .force_loyalty_coins_conversion_rates_to_1_eur_or_1_usd_equals_20_mxn_enabled;
  const {
    conversionRates,
  } = state.loyalty;
  if (finalCurrency == null) {
    // Tuvimos que agregar al método convertCoinsToCurrency el parámetro opcional currency, ya que
    // va al store y toma el currency de state.booking.filterCurrency, lo cual no coincidiría
    // con el currency que se toma de la ip del usuario
    finalCurrency = state.booking.filterCurrency;
  }
  const conversionRate = conversionRates.find((element) => element.currency_code === finalCurrency.code);
  //force_loyalty_coins_conversion_rates_to_1_eur_or_1_usd_equals_20_mxn_enabled
  let conversionRateValue = conversionRate !== undefined ? conversionRate.value : 1;
  if (force_conversion_1_eur_or_1_usd_equals_20_mxn_enabled === true) {
    if (finalCurrency.code === 'EUR' || finalCurrency.code === 'USD') {
      conversionRateValue = 1;
    } else if (finalCurrency.code === 'MXN') {
      conversionRateValue = 20;
    } else if (conversionRate !== undefined) {
      conversionRateValue = conversionRate.value;
    } else {
      conversionRateValue = 1; // Valor por defecto
    }
  }

  const result = coins * conversionRateValue;
  const roundedResult = Math.round(result * 100) / 100; // 123.46
  return roundedResult;
};

export {
  showLoyaltyClaimPopup,
  showLoyaltyRegisterNow,
  showLoyaltyRedeem,
  showLoyaltySelector,
  getMaxCoinsToApply,
  convertCoinsToCurrency,
  convertCoinsToCurrencyUsingRoundedConversionRate,
};
